import { PoposedToTheSubCommittee4ViewContainer } from "../../../containers/borrowSystem/ProposedToTheSubCommittee/PoposedToTheSubCommittee4ViewContainer";
export function PoposedToTheSubCommittee4ViewPage () {

    return(
        <PoposedToTheSubCommittee4ViewContainer/>
    )
}




